import FourUp from './FourUp'

export default FourUp